import { callApi } from "@/api/api-core";

export const fetchInfo = function(ownerHandlesFailure) {
    return callApi(
        "POST",
        "v1/products/dsbseatticket/info",
        undefined,
        ownerHandlesFailure
    );
};

export const calculatePrice = function(
    tripId,
    passengersCount,
    ownerHandlesFailure
) {
    return callApi(
        "POST",
        "v2/products/dsbseatticket/price/calculate",
        {
            tripId,
            passengersCount
        },
        ownerHandlesFailure
    );
};

export const createOrder = function(
    productVariantId,
    seatTypeId,
    passengersCount,
    ownerHandlesFailure
) {
    return callApi(
        "POST",
        "v2/products/dsbseatticket/order",
        {
            productVariantId,
            seatTypeId,
            passengersCount,
            salesChannelIdentifier: "Webshop"
        },
        ownerHandlesFailure
    );
};
